import axios from 'axios';

// Use environment variable or fallback to production URL
const API_BASE_URL = process.env.NODE_ENV === 'production' 
    ? 'https://uswellness.co.ke/api'
    : 'http://localhost:5000/api';

const api = axios.create({
    baseURL: API_BASE_URL,
    headers: {
        'Content-Type': 'application/json',
    },
});

// ==================== PRODUCT SERVICES ====================
export const productService = {
    // Get all products
    getProducts: async (params = {}) => {
        const response = await api.get('/products', { params });
        return response.data;
    },

    // Get single product by ID (since Node.js uses id, not slug)
    getProductById: async (id) => {
        const response = await api.get(`/products/${id}`);
        return response.data;
    },

    // Create a product
    createProduct: async (productData) => {
        const response = await api.post('/products', productData);
        return response.data;
    },

    // Update a product
    updateProduct: async (id, productData) => {
        const response = await api.put(`/products/${id}`, productData);
        return response.data;
    },

    // Delete a product
    deleteProduct: async (id) => {
        const response = await api.delete(`/products/${id}`);
        return response.data;
    },
};

// ==================== CATEGORY SERVICES ====================
export const categoryService = {
    getCategories: async () => {
        // Get categories from products
        const response = await api.get('/products');
        const products = response.data;
        // Extract unique categories
        const categories = [...new Set(products.map(p => p.category).filter(Boolean))];
        return categories;
    },
};

// ==================== TESTIMONIAL SERVICES ====================
// Note: Testimonials are not in Node.js backend yet
// You can either remove this or create a testimonials endpoint
export const testimonialService = {
    getTestimonials: async () => {
        // Placeholder - return empty array or fetch from a different source
        return [];
    },
    getLatestTestimonials: async () => {
        return [];
    },
};

// ==================== UPLOAD SERVICE ====================
export const uploadService = {
    uploadImage: async (file) => {
        const formData = new FormData();
        formData.append('image', file);
        const response = await api.post('/upload', formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        });
        return response.data;
    },
};

export default api;